import React from 'react';
import { SmileyType } from './types';
import * as S from './styles';

type OwnProps = {
  type:
    | SmileyType.ANGRY
    | SmileyType.DISSATISFIED
    | SmileyType.NEUTRAL
    | SmileyType.SMILING
    | SmileyType.LAUGHING;
  disabled: boolean;
  size?: number;
};

const RatingIcon = ({ disabled, size, type }: OwnProps) => {
  switch (type) {
    case SmileyType.ANGRY:
      return <S.Angry disabled={disabled} size={size} />;
    case SmileyType.DISSATISFIED:
      return <S.Dissatisfied disabled={disabled} size={size} />;
    case SmileyType.NEUTRAL:
      return <S.Neutral disabled={disabled} size={size} />;
    case SmileyType.SMILING:
      return <S.Smiling disabled={disabled} size={size} />;
    case SmileyType.LAUGHING:
      return <S.Laughing disabled={disabled} size={size} />;
    default:
      return null;
  }
};

export default RatingIcon;
